import React from "react";
import {FormControl, MenuItem, Select, SelectChangeEvent} from "@mui/material";
import {FilterEnumValue} from "./types";
import {useTranslation} from "react-i18next";

export const FilterSelectComponent = <T,>({
    inputRef,
    value,
    onChange,
    enumValues,
    multiple,
}: {
    inputRef: React.Ref<any>;
    value: T;
    onChange: (event: SelectChangeEvent<T>) => void;
    enumValues?: FilterEnumValue[];
    multiple?: boolean;
}) => {
    const {t} = useTranslation();
    return (
        <FormControl margin={"dense"} sx={{minWidth: 145, mr: 1}} size="small">
            <Select inputRef={inputRef} value={value} onChange={onChange} multiple={multiple}>
                {enumValues?.map((ev) => (
                    <MenuItem key={ev.labelKey} value={ev.value}>
                        {t(ev.labelKey)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
